module.exports = __webpack_public_path__ + "static/img/aboutUs18.c3bf829.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs18.jpg
// module id = 1370
// module chunks = 1